import { Map } from 'immutable';
export const transportStatus = Map.of(
  'LOADPORT', 'On the way to loadport',
  'LOADING', 'Loading',
  'DISCHARGEPORT', 'On the way to discharge port',
  'DISCHARGING', 'Discharging',
);
export const vesselLoadingStatus = Map.of(
  'EMPTY', '',
  'PREV_CARGO_VOYAGE', 'Under voyage with previous cargo',
  'ON_THE_WAY_TO_PORT', 'On the way to port',
  'ARRIVED', 'Arrived, waiting to berth',
  'BERTHERED', 'Berthed, waiting to load',
  'LOADING_DISCHARGING', 'Loading',
  'COMPLETED', 'Loading completed, waiting to sail',
  'SAILED', 'Loading completed, sailed',
);

export const containerLoadingStatus = Map.of(
  'EMPTY', '',
  'ON_THE_WAY_TO_PORT', 'On the way to port',
  'ARRIVED', 'Arrived, waiting to berth',
  'BERTHERED', 'Berthed, waiting to load',
  'LOADING_DISCHARGING', 'Loading',
  'COMPLETED', 'Loading completed, waiting to sail',
  'SAILED', 'Loading completed, sailed',
);

export const vesselDischargingStatus = Map.of(
  'EMPTY', '',
  'ON_THE_WAY_TO_PORT', 'On the way to port',
  'ARRIVED', 'Arrived, waiting to berth',
  'BERTHERED', 'Berthed, waiting to discharge',
  'LOADING_DISCHARGING', 'Discharging',
  'COMPLETED', 'Discharge completed, waiting to sail',
  'SAILED', 'Discharge completed, sailed',
);

export const railcarLoadingStatus = Map.of(
  'EMPTY', '',
  'RWPLAN_RECEIVED', 'RWPlan received',
  'LOADING_DISCHARGING', 'Loading',
  'COMPLETED', 'Loading completed - Cargo on the way',
  'DELIVERED', 'Delivered',
);
